export const pluralizeText = (count, text) => {
  return count > 1 ? `${count} ${text}s` : `${count} ${text}`;
};
export const pluralizeTextWithoutCount = (count, text) => {
  return count > 1 ? `${text}s` : `${text}`;
};
